<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
  >
    <path d="M14.7919 9.26536C15.0765 8.96443 15.0633 8.48974 14.7624 8.20511C14.4614 7.92049 13.9868 7.93371 13.7021 8.23464L8.74702 13.4737V0.75C8.74702 0.335786 8.41123 0 7.99702 0C7.58281 0 7.24702 0.335786 7.24702 0.75V13.476L2.28976 8.23464C2.00514 7.93371 1.53045 7.92049 1.22952 8.20511C0.928581 8.48974 0.91536 8.96443 1.19999 9.26536L7.26943 15.6826C7.42671 15.8489 7.62682 15.9489 7.83561 15.9826C7.8876 15.994 7.94161 16 7.99702 16C8.05461 16 8.11069 15.9935 8.16456 15.9812C8.37036 15.9462 8.56726 15.8467 8.72247 15.6826L14.7919 9.26536Z" />
  </svg>
</template>
